import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-mandatory-criteria-dialog',
  templateUrl: './mandatory-criteria-dialog.component.html',
  styleUrls: ['./mandatory-criteria-dialog.component.scss'],
  standalone: false,
})
export class MandatoryCriteriaDialogComponent {
  unmetCriteria: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { unmetCriteria: string[] } | null,
    private dialogRef: MatDialogRef<MandatoryCriteriaDialogComponent>
  ) {
    this.unmetCriteria = this.data?.unmetCriteria || [];
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
